import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a07295ff6558f00147e34f2_1782149188837_d433db34/globalatlas/src/app/maritime-risk/page.tsx");
